/*
 * @Author: zcj
 * @Date: 2025-01-15 19:46:53
 * @LastEditTime: 2026-02-11 20:51:34
 * @LastEditors: 'zcj' '2736104855@qq.com'
 * @Description:
 * @FilePath: \h5e:\travel-app\src\main.ts
 */
import { createSSRApp } from 'vue'
import App from './App.vue'
import store from './store'
import { routeInterceptor, requestInterceptor, prototypeInterceptor } from './interceptors'
import 'virtual:uno.css'
import '@/style/index.scss'
import NavBar from '@/components/lz-navBar/navBar.vue'
import networkController from '@/utils/networkMonitoring'
import { setupClickInterceptor } from './interceptors/clickInterceptor'
setupClickInterceptor()
networkController()
import share from '@/utils/share'
// #ifdef H5
// 只在非开发环境下引入WxShare
let WxShare: any = null;
window._AMapSecurityConfig = {
  securityJsCode: 'fb81b3295915fed2d9a7ed393a6cbdbb',
}
import AMapLoader from '@amap/amap-jsapi-loader'
import Vue3CupUi from '@/uni_modules/vue3-cup-ui/lib/vue3-cup-ui'
import '@/uni_modules/vue3-cup-ui/lib/vue3-cup-ui.common.css'
// import VConsole from 'vconsole'
// const console = new VConsole()
//  #endif
export function createApp() {
  const app = createSSRApp(App)
  app.component('NavBar', NavBar)
  app.mixin(share) // 使用mixin全局混入
  // #ifdef H5
  app.use(Vue3CupUi)
  // 在所有环境下注册微信分享插件
  import('@/utils/h5_share').then((module) => {
    WxShare = module.default
    app.use(WxShare, {
      title: '跨界免息分期 机票酒店用车旅游',
      desc: '全场分期 0利息0手续费 40家银行信任支持的平台。',
      imgUrl: 'https://product-wjb-cloud.oss-cn-beijing.aliyuncs.com/base/logo.png'
    })
    // console.log('WxShare插件已注册到Vue实例')
  })
  // app.use(console)
  AMapLoader.load({
    key: '901921de42f6f10a9d485ef8a812fee4', // 申请好的Web端开发者Key，首次调用 load 时必填
    version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: ['AMap.Geolocation', 'AMap.Geocoder', 'AMap.Driving'],
    resizeEnable: true,
  })
    .then((AMap) => {
      app.config.globalProperties.$AMap = AMap
    })
    .catch((e) => {
      console.log(e)
    })
  //  #endif
  app.use(store)
  app.use(routeInterceptor)
  app.use(requestInterceptor)
  app.use(prototypeInterceptor)
  return {
    app,
  }
}
